import React from "react";
import { getDisplayName } from "../utils/displayName";
import { useNavigate } from "react-router-dom";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";

const ProfessionalCard = ({ professional }) => {
  const nav = useNavigate();

  const handleClick = (user_id) => {
    if (!user_id) return;
    nav(`/user/${user_id}`);
  };

  const fullName = getDisplayName(professional) || "Name unavailable";

  const displayType =
    professional?.class_type || "Professional type unavailable";
  const company = professional?.brokerage_name || "Company unavailable";
  const photoSrc = professional?.picture_url
    ? cloudinaryUrl(professional.picture_url)
    : "https://via.placeholder.com/400x300?text=No+Image";

  const getProfessionalBadgeColor = (classType) => {
    switch (classType) {
      case "Realtor":
        return "bg-blue-500";
      case "Lender":
        return "bg-purple-500";
      case "Title Company":
        return "bg-green-500";
      case "Builder":
        return "bg-orange-500";
      case "Broker":
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  return (
    <div
      className="bg-white rounded-lg shadow-lg hover:shadow-xl hover:scale-[1.03] hover:cursor-pointer transition-all group overflow-hidden"
      onClick={() => handleClick(professional?.user_id)}
    >
      {/* Professional Type Badge */}
      <div className="relative h-48 overflow-hidden bg-gradient-to-br from-slate-100 to-slate-200">
        <img
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          src={photoSrc}
          alt={fullName}
        />
        <div
          className={`absolute top-2 right-2 ${getProfessionalBadgeColor(
            professional?.class_type
          )} text-white px-3 py-1 rounded-full text-xs font-bold shadow-md`}
        >
          {professional?.class_type || "N/A"}
        </div>
      </div>

      {/* Professional Info */}
      <div className="p-4">
        <h3 className="text-lg font-bold text-gray-900 truncate">{fullName}</h3>
        <p className="text-xs font-semibold text-gray-600 mb-2">
          {displayType}
        </p>
        <p className="text-sm text-gray-600 truncate mb-3">{company}</p>
        <div className="flex items-center justify-center">
          <button className="w-full bg-blue-500 text-white py-2 px-3 rounded font-semibold text-sm hover:bg-blue-600 transition-colors">
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalCard;
